
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.5 1.752h7a2.333 2.333 0 012.333 2.334v7a2.333 2.333 0 01-2.334 2.333h-7a2.333 2.333 0 01-2.333-2.333v-7a2.333 2.333 0 012.333-2.334zm8.03 10.365c.274-.274.428-.644.428-1.031v-7a1.458 1.458 0 00-1.459-1.459h-7c-.805 0-1.458.653-1.458 1.459v7a1.458 1.458 0 001.458 1.458h7c.387 0 .758-.154 1.031-.427z","fill":"#C4C4C4"}}),_c('path',{attrs:{"d":"M9.152 5.678a.437.437 0 00-.618 0L7.122 7.09 5.71 5.678a.437.437 0 00-.618.619l1.412 1.411L5.092 9.12a.438.438 0 00.618.618l1.412-1.411 1.412 1.411a.437.437 0 10.618-.618L7.74 7.708l1.412-1.411a.437.437 0 000-.619z","fill":"#C4C4C4"}})])
          )
        }
      }
    